var map = {
	"./amcc-logo.png": "5oTX",
	"./as-logo.png": "9sJt",
	"./cu-logo.png": "Rboi",
	"./dc-logo.png": "3xB4",
	"./fu-logo.png": "lOsR",
	"./hc-logo.png": "i1pF",
	"./lru-logo.png": "ox6e",
	"./ma-logo.png": "Uv5K",
	"./mc-logo.png": "BAWS",
	"./pb-logo.png": "X7bJ",
	"./pg-logo.png": "nVtV",
	"./psa-logo.png": "Qf8P",
	"./psb-logo.png": "E5X5",
	"./site-logo.png": "/K6P",
	"./wc-logo.png": "wrEY"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "D9X8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos ^\.\/.*\-logo\.png$
// module id = D9X8
// module chunks = 1